export default {
	dsn: import.meta.env.VUE_APP_SENTRY_DSN,
	release: `${import.meta.env.VUE_APP_TARGET}@${import.meta.env.VUE_APP_VERSION}-${
		import.meta.env.VUE_APP_SHORT_HASH
	}`,
	environment: import.meta.env.MODE,
	attachProps: false,
	logErrors: true,
	ignoreErrors: [
		// Comming from video in session page https://bugs.chromium.org/p/chromium/issues/detail?id=809574
		'ResizeObserver loop limit exceeded',
		// Ignore rare IndexedDB issues we can't do anything about, which spam Sentry logs to an unbearable degree.
		// These issues are not entirely swallowed - debounced errors are sent to Sentry from `indexedDB.js`.
		`IndexedDB connection terminated`,
		`Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing.`,
		'UnknownError: Internal error opening backing store for indexedDB.open.',
		'UnknownError: Internal error committing transaction.',
		'DataError: Failed to read large IndexedDB value',
		'AbortError: AbortError',
		// Ignore exception during DOM playback, see e.g. https://bird-eats-bug.sentry.io/issues/4040187945
		'The play() request was interrupted because the media was removed from the document.',
		`Cannot read properties of null (reading 'scrollTo')`,
		// Ignore exception from outdated browser running our extension, see https://bird-eats-bug.sentry.io/issues/5414798440/
		'runtime.getContexts is not a function',
		// Ignore issue that popped up with MV 3 transition, probably due to the offscreen page - it does not have any traces attached, and has not been connected to issues experienced by users yet.
		'Frame with ID 0 is showing error page',
	],
}
